import { ProviderWebsiteModel } from '../../../shared/models/provider-website-model';
import { Serializable } from '../../../core/models/serializable';

export class ChannelJobseekerStatModel
  implements Serializable<ChannelJobseekerStatModel>
{
  fromObject(obj: any): ChannelJobseekerStatModel {
    Object.assign(this, obj);
    this.channel = null;

    if (obj.channel != null) {
      let t = new ProviderWebsiteModel();
      t = t.fromObject(obj.channel);
      this.channel = t;
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public totalCount: number;
  public totalActiveCount: number;
  public countWithBasicProfile: number;
  public countWithCompleteProfile: number;
  public uniqueCount: number;
  public countPerChannel: number;
  public channel: ProviderWebsiteModel;
}
